export const DEFAULT_ACTION ="app/AssignBlocksSubmittedCases/DEFAULT_ACTION";
export const FORMDATA = "app/AssignBlocksSubmittedCases/BLOCKDATA";
export const SETFORMDATA = "app/AssignBlocksSubmittedCases/BLOCKDATA/SET/VALUE";